import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";

interface MembershipOptionsProps {
  onSelectType: (type: "active" | "benefactor" | "donor") => void;
  donationAmount: number;
  setDonationAmount: (amount: number) => void;
  selectedType: "active" | "benefactor" | "donor" | null;
}
export function MembershipOptions({
  onSelectType,
  donationAmount,
  setDonationAmount,
  selectedType
}: MembershipOptionsProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md">
      <h2 className="text-2xl font-semibold text-center mb-6 text-[#00123A]">Choisissez votre type d'adhésion</h2>
      <div className="flex flex-col md:flex-row gap-6 justify-center">
        <button onClick={() => onSelectType("active")} className={`flex-1 p-6 rounded-lg transition-all duration-300 flex flex-col
            ${selectedType === "active" ? "bg-[#FCACF4] border-4 border-[#00123A] shadow-lg transform scale-[1.02]" : selectedType ? "bg-[#FCACF4]/20 text-[#00123A]/70 hover:bg-[#FCACF4]/30" : "bg-[#FCACF4] hover:bg-[#FCACF4]/90 text-[#00123A] shadow-sm"}`}>
          <span className="font-bold text-lg mb-4">Devenez Membre ACTIF</span>
          <ul className="text-left text-sm mb-4 space-y-2 flex-1">
            <li className="flex items-start">
              <span className="mr-2">-</span>
              <span>Je signe et je reçois la charte Enfants de la République à mon nom</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">-</span>
              <span>Je suis informé(e) des actions à venir et de comment y prendre part</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">-</span>
              <span>Je dispose d'un contact direct pour proposer mes initiatives</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">-</span>
              <span>Je verse annuellement la somme de 50euros à titre de cotisation</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">-</span>
              <span>J'obtiens 1 voix à l'assemblée générale</span>
            </li>
          </ul>
          <div className="font-bold text-xl mt-auto flex items-center justify-center flex-col">
            <span>50€</span>
            <p className="text-xs mt-1 font-bold text-center">ne vous coûtera que 17€ après déduction fiscale, un CERFA vous sera envoyé</p>
            <ChevronDown className="mt-1 w-5 h-5 animate-bounce" />
          </div>
        </button>
        
        <button onClick={() => onSelectType("benefactor")} className={`flex-1 p-6 rounded-lg transition-all duration-300 flex flex-col
            ${selectedType === "benefactor" ? "bg-[#FCACF4] border-4 border-[#00123A] shadow-lg transform scale-[1.02]" : selectedType ? "bg-[#FCACF4]/20 text-[#00123A]/70 hover:bg-[#FCACF4]/30" : "bg-[#FCACF4] hover:bg-[#FCACF4]/90 text-[#00123A] shadow-sm"}`}>
          <span className="font-bold text-lg mb-4">Devenez Membre BIENFAITEUR</span>
          <ul className="text-left text-sm mb-4 space-y-2 flex-1">
            <li className="flex items-start">
              <span className="mr-2">-</span>
              <span>Je signe et je reçois la charte Enfants de la République à mon nom</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">-</span>
              <span>Je suis informé(e) des actions à venir et de comment y prendre part</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">-</span>
              <span>Je dispose d'un contact direct pour proposer mes initiatives</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">-</span>
              <span>J'obtiens 5 voix à l'assemblée générale.</span>
            </li>
          </ul>
          <div className="font-bold text-xl mt-auto flex items-center justify-center flex-col">
            <span>700€</span>
            <p className="text-xs mt-1 font-normal text-center">Je verse un droit d'entrée de 500 euros et une cotisation annuelle de 200 euros.</p>
            <p className="text-xs mt-1 font-bold text-center">ne vous coûtera que 238€ après déduction fiscale, un CERFA vous sera envoyé</p>
            <ChevronDown className="mt-1 w-5 h-5 animate-bounce" />
          </div>
        </button>
        
        <button onClick={() => onSelectType("donor")} className={`flex-1 p-6 rounded-lg transition-all duration-300 flex flex-col
            ${selectedType === "donor" ? "bg-[#FCACF4] border-4 border-[#00123A] shadow-lg transform scale-[1.02]" : selectedType ? "bg-[#FCACF4]/20 text-[#00123A]/70 hover:bg-[#FCACF4]/30" : "bg-[#FCACF4] hover:bg-[#FCACF4]/90 text-[#00123A] shadow-sm"}`}>
          <span className="font-bold text-lg mb-4">Devenez DONATEUR</span>
          <ul className="text-left text-sm mb-4 space-y-2 flex-1">
            <li className="flex items-start">
              <span className="mr-2">-</span>
              <span>Je soutiens financièrement les actions et les projets de transmission, de renforcement et de protection de la charte proposée par l'association</span>
            </li>
          </ul>
          <div className="mt-auto" onClick={e => e.stopPropagation()}>
            <label htmlFor="donation-amount" className="block text-sm font-medium mb-1">
              Montant de votre don (€)
            </label>
            <Input 
              id="donation-amount" 
              type="number" 
              min="0" 
              value={donationAmount === 0 ? "" : donationAmount} 
              onChange={e => {
                const value = e.target.value;
                setDonationAmount(value === "" ? 0 : Number(value));
              }}
              className="bg-white border border-gray-300 w-full mb-2" 
              onClick={e => e.stopPropagation()} // Éviter la propagation du clic vers le parent
            />
            <Button onClick={e => {
            e.stopPropagation(); // Éviter la propagation du clic vers le parent
            onSelectType("donor");
          }} className="w-full bg-[#00123A] text-white py-2 px-4 rounded hover:bg-[#00123A]/80 transition-colors">
              Faire un don de {donationAmount}€
            </Button>
          </div>
        </button>
      </div>
    </div>;
}
